import { cn } from '../lib/cn.js';

interface StatusChipProps {
  status: string;
  className?: string;
}

/**
 * Predefined color mapping for transfer/lifecycle statuses.
 * - Completed / Paid out → green
 * - Cancelled / Failed / Refunded → red
 * - Draft / Pending KYC → orange (action needed)
 * - Everything else → grey (pending/progress)
 */
const STATUS_COLORS: Record<string, string> = {
  COMPLETED: 'bg-success/12 text-success border-success/20',
  PAID_OUT: 'bg-success/12 text-success border-success/20',
  CANCELLED: 'bg-danger/10 text-danger border-danger/15',
  FAILED: 'bg-danger/10 text-danger border-danger/15',
  REFUNDED: 'bg-danger/10 text-danger border-danger/15',
  DRAFT: 'bg-warning/12 text-warning border-warning/20',
  PENDING_KYC: 'bg-warning/12 text-warning border-warning/20',
  PENDING_PAYMENT: 'bg-surface-elevated text-text-muted border-border',
  PROCESSING: 'bg-surface-elevated text-text-muted border-border',
  PAYMENT_RECEIVED: 'bg-success/12 text-success border-success/20',
  active: 'bg-success/12 text-success border-success/20',
  suspended: 'bg-danger/10 text-danger border-danger/15',
};

const DEFAULT_COLOR = 'bg-surface-elevated text-text-muted border-border';

export function StatusChip({ status, className }: StatusChipProps) {
  const colorClass = STATUS_COLORS[status] ?? DEFAULT_COLOR;
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-pill border px-2.5 py-0.5 text-xs font-semibold uppercase tracking-wider',
        colorClass,
        className,
      )}
    >
      {status.replace(/_/g, ' ')}
    </span>
  );
}
